import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode"; // Si necesitas decodificar el JWT

const clientId = "1095974763839-lo7q0nt3mb5igcuohvfo3c486cijf19p.apps.googleusercontent.com"; // Reemplaza con tu Client ID

const LoginButton = ({  onSuccess, onError }) => {
  const handleLogin = async (googleData, ) => {
    const user = jwtDecode(googleData.credential);
    onSuccess(user)
  };

  return (
    <GoogleLogin 
      onSuccess={handleLogin}
      onError={onError}
    />
  );
};

const GoogleSign = ({ onSuccess, onError }) => (
  <GoogleOAuthProvider clientId={clientId} >
      <LoginButton onSuccess={onSuccess} onError={onError} />
  </GoogleOAuthProvider>
);

export default GoogleSign;
